import { useRootStore } from 'stores/utils/hooks/useRootStore'
import { getAgeGroupFromAge } from 'stores/helpers/AgeGroups'
import { AgeGroup } from 'constants/components'
import { isPremiumCustomer } from 'utils/user'
import { getAge } from 'utils/date'
import { getRceCustomerCategory } from 'utils/getRceCustomerCategory'
import type RootStore from 'stores/RootStore'

export type UserState = {
  isPremium: boolean
  isYoungAge: boolean
  isMiddleAge: boolean
  isOldAge: boolean
  isSalableCustomer: boolean
  isAcceptedCustomer: boolean
  isAbortedCustomer: boolean
  isAbortedDacCompleteCustomer: boolean
  ageGroup: AgeGroup
  debtorsAge: number
  debtorsCount: number
}

// Pure function — for config-level and test usage
export function getUserState(rootStore: RootStore): UserState {
  const { traversal } = rootStore
  const birthday = traversal.data?.debtors?.primary?.personal?.birthday ?? ''
  const amount = traversal.data?.common?.amount ?? 0
  const primaryIncome = traversal.data?.debtors?.primary?.income?.primary ?? 0
  const debtorsAge = birthday ? getAge(birthday) : 0
  const ageGroup = getAgeGroupFromAge(debtorsAge)

  return {
    isPremium: isPremiumCustomer({
      debtorsAge,
      amount,
      income: { primary: primaryIncome }
    }),
    isYoungAge: ageGroup === AgeGroup.YOUNG_AGE_GROUP,
    isMiddleAge: ageGroup === AgeGroup.MIDDLE_AGE_GROUP,
    isOldAge: ageGroup === AgeGroup.OLD_AGE_GROUP,
    ...getRceCustomerCategory({
      utm_campaign: rootStore.urlParams.utm_campaign,
      parentUrl: rootStore.navigation?.parentUrl
    }),
    ageGroup,
    debtorsAge,
    debtorsCount: traversal.data?.debtors?.count ?? 1
  }
}

// Reactive hook — MobX tracks accessed observables via observer()
function useUserState(): UserState {
  const { rootStore } = useRootStore()
  return getUserState(rootStore)
}

export default useUserState
